import {
    SET_SUBCATEGORIES_MARKETPLACE_PRODUCTS,
    SET_CATEGORIES_MARKETPLACE_PRODUCTS,
    SET_COMPANIES_LIST_TYPE_DOCUMENT,
    SET_ALL_MONETIZATION_TYPES,
    SET_FUNCTIONALITIES,
    SET_COMPANIES_BY_ID,
    SET_COMPANIES,
    SET_COMPANY_DEMO_TYPES,
} from "@/views/companies/store/types/types.js";

const mutations = {
    [SET_SUBCATEGORIES_MARKETPLACE_PRODUCTS]: (state, payload) => state.subCategoriesProducts = payload,
    [SET_CATEGORIES_MARKETPLACE_PRODUCTS]: (state, payload) => state.categoriesProducts = payload,
    [SET_COMPANIES_LIST_TYPE_DOCUMENT]: (state, payload) => state.companyTypeId = payload,
    [SET_ALL_MONETIZATION_TYPES]: (state, payload) => state.monetizationTypes = payload,
    [SET_FUNCTIONALITIES]: (state, payload) => state.functionalities = payload,
    [SET_COMPANIES_BY_ID]: (state, payload) => state.companyById = payload,
    [SET_COMPANIES]: (state, payload) => state.companies = payload,
    [SET_COMPANY_DEMO_TYPES]: (state, payload) => state.companyDemoTypes = payload,
}

export default mutations;